import { Box, Text } from "ui-kit/components-branded/index"
import { TherapyRequest } from "modules/HRAccount/api"
import { Title } from "modules/HRAccount/Title"
import { formatNumber } from "utils/utils"

export function TopRequests({ requests }: { requests: TherapyRequest[] }) {
    return (
        <Box className="has-constant-gaps is-big-gaps">
            <Title dataTestId="top-requests" className="mgb-3">
                Отчет по&nbsp;запросам
            </Title>
            <Text isAccent className="mgb-4 is-block">
                Популярные запросы за&nbsp;период
            </Text>
            <Text>
                <table>
                    <colgroup>
                        <col width="100%"></col>
                        <col></col>
                    </colgroup>
                    <tbody>
                        {requests.map((item, index) => (
                            <tr key={index}>
                                <td className="hr-account__data-row">{item.top_competence}</td>
                                <td className="hr-account__align-right">
                                    {formatNumber(Math.round(item.percentage * 10) / 10)}%
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </Text>
        </Box>
    )
}
